export default __webpack_public_path__ + "static/media/placeholder_occhiali_gray.547b4631.svg";